module.exports = __webpack_public_path__ + "media/images/display/blur-text-2-b0ada99a3d202b40e5c84f196e839050.png";